<template>
  <Main />
</template>

<script>
import Main from '@/components/Main.vue';

export default {
  name: 'App',
  components: {
    Main
  }
};
</script>

<style lang="scss">
@import '@/App.scss';

#app {
  font-family: 'Open Sans', sans-serif;
}
</style>
